import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, Divider, IconButton, Drawer as MuiDrawer, Stack, Typography } from "@mui/material";
import { CSSObject, Theme, styled, useTheme } from "@mui/material/styles";
import React from "react";
import { Outlet } from "react-router";
import { useLocation } from "react-router-dom";

import { GemRoutes } from "../../Routes";
import Navigation from "../Navigation/Navigation";
import AdminDrawerItems from "./AdminDrawerItems";

const drawerWidth = 270;

const Admin: React.FC = () => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const location = useLocation();
  return (
    // flexDirection="column" flexGrow={1}
    <Stack width="100%" height="100%" display="flex" flexGrow={1}>
      <Box display="flex" flex={1}>
        <Navigation position="fixed" drawerOpenSize={drawerWidth} drawerCollapsedSize={65} isDrawerOpen={open} />
        <Drawer variant="permanent" open={open}>
          <DrawerHeader sx={{ backgroundColor: theme.palette.primary.main }}>
            <IconButton onClick={() => setOpen(currentState => !currentState)}>
              {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <AdminDrawerItems isOpen={open} />
        </Drawer>
        <Box component="main" display="flex" flexDirection="column" flex={1} width="100%">
          <DrawerHeader />
          {location.pathname == GemRoutes.Admin ? (
            <Box width="100%" display="flex" justifyContent="center" alignItems="center" pt="25%">
              <Typography variant="h4" color={theme => theme.palette.grey[700]}>
                Please select a tool to get started.
              </Typography>
            </Box>
          ) : (
            <Outlet />
          )}
        </Box>
      </Box>
    </Stack>
  );
};

export default Admin;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: "hidden"
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`
  }
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  "@media all": { minHeight: 80 }
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: prop => prop !== "open" })(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme)
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme)
  })
}));
